<div class="location-palette-container">
    <div class="text-center safezone-overlay">

        <button class="btn btn-light close-btn" (click)="cancelSafeZoneClicked()">
            <i class="fa fa-times"></i>
        </button>

        <div class="mb-3" style="width: 75px; margin: 0 auto;">
            <button type="button" class="btn btn-danger" style="width: 75px;" (click)="cancelSafeZoneClicked()">
                <i class="bi bi-x"></i>
                <br />
                Cancel
            </button>
        </div>

        <div class="body-text">
            Click anywhere on the globe to create a Safe Zone.Click the OK button to finish.
        </div>
    </div>
</div>